// 校验特殊字符
var specialValidate = (rule, value, callback) => {
  // var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
  // if (value.match(reg)) {
  //     callback(new Error("请勿输入表情"));
  // } else {
  callback();
  // }
};
export default {
  formRules: {
    editReason: [
      {
        required: true,
        message: window.vm.$t('warehouseContract.form.editResonPlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
    contractEnterpriseNo: [
      {
        required: true,
        message: window.vm.$t('warehouseContract.form.contractEnterpriseNoPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      //     min: 1,
      //     max: 40,
      //     message: "长度在 1 到 40 个字符",
      //     trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    registeredAssets: {
      required: true,
      message: window.vm.$t('warehouseContract.form.registeredAssetsPlaceholder'),
      trigger: ['change', 'blur'],
    },
    contactPersonNo: [
      {
        required: true,
        message: window.vm.$t('warehouseContract.form.contactPersonNoPlaceholder'),
        trigger: ['change', 'blur'],
      },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    contactPhone: [
      {
        required: true,
        message: window.vm.$t('warehouseContract.form.contactPhonePlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    signDate: [
      {
        required: true,
        message: window.vm.$t('warehouseContract.form.signDatePlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    valideDateTo: [
      {
        required: true,
        message: window.vm.$t('warehouseContract.form.valideDateToPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    inboundMethod: [
      {
        required: true,
        message: window.vm.$t('warehouseContract.form.inboundMethodPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    stationName: [
      {
        required: true,
        message: window.vm.$t('warehouseContract.form.stationNamePlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    goodsControlAmount: [
      {
        required: true,
        message: window.vm.$t('warehouseContract.form.goodsControlAmountPlaceholder'),
        trigger: ['change', 'blur'],
      },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    contractVenue: [
      {
        required: true,
        message: window.vm.$t('warehouseContract.form.contractVenuePlaceholder'),
        trigger: ['change', 'blur'],
      },
      //{
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    chargeStandard: [
      {
        required: true,
        message: window.vm.$t('warehouseContract.form.chargeStandardPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    feature: [
      {
        required: true,
        message: window.vm.$t('warehouseContract.form.featurePlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
  },
  warehouseEditRules: {
    storageNo: [
      {
        required: true,
        message: window.vm.$t('warehouseContract.form.storageNoPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    storageName: [
      {
        required: true,
        message: window.vm.$t('warehouseContract.form.storageNoPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    storageAddress: [
      {
        required: true,
        message: window.vm.$t('warehouseContract.form.storageAddressPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
  },
  productEditRules: {
    storageNo: [
      {
        required: true,
        message: window.vm.$t('warehouseContract.form.storageNoPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    storageName: [
      {
        required: true,
        message: window.vm.$t('warehouseContract.form.storageNoPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    productGood: [
      {
        required: true,
        message: window.vm.$t('warehouseContract.form.productGoodPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    storageExpense: [
      {
        required: true,
        message: window.vm.$t('warehouseContract.form.storageExpensePlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
  },
};
